import React from 'react';
import classNames from "classnames";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

class TopMenu extends React.Component {

    render() {
        const {classes, children} = this.props;

        return (
            <div className={classNames(classes.menu, classes.topMenu)}>
              <GridContainer justify="center" spacing={16} >
                  {React.Children.map(children, (child, i) => {
                    if (child != null) {
                      return (
                        <GridItem xs={child.props.xs} sm={child.props.sm} md={child.props.md} lg={child.props.lg} className={classes.topControl}>
                          {child}
                        </GridItem>
                      );
                    } else {
                      return null;
                    }
                  })}
              </GridContainer>
            </div>
        );
    }
}

export default withStyles(mapStyle)(TopMenu);